package smartTcm.components


import antd.alert.alert
import antd.button.button
import antd.form.formItem
import antd.radio.radioButton
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.optGroup
import antd.select.select
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordSignSymptomCharacteristicState
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordSignSymptomState
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import com.jingfangpai.medicalRecord.model.MedicalRecordRawData
import com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem
import external.select.filterOptionFun
import kotlinext.js.Object
import kotlinext.js.js
import react.*
import react.dom.*

external interface DiagnosisConversationComponentProps : RProps {
    var patientId:String
    var signSymptomOptions:Array<CascadedOption<String>>
    var getNextDiagnosisItem:(currentItems: MedicalRecordRawData, okCallback: (result: ApiResponse<Array<DiagnosisQuestionAndAnswerItem>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    var onSubmit: (MedicalRecordRawData, (ApiResponse<MedicalRecord>)->Unit, (Throwable)->Unit)->Unit
}

data class DiagnosisConversationComponentContextData(var placeHolderFunction: (param: String) -> Unit)

val DiagnosisConversationComponent = functionalComponent<DiagnosisConversationComponentProps> { props ->

    val (conversationItems,setConversationItems) = useState<Array<DiagnosisQuestionAndAnswerItem>>(arrayOf())
    val (statusMessage,setStatusMessage) = useState("")

    useEffectOnce {
        setConversationItems(arrayOf(
            DiagnosisQuestionAndAnswerItem().apply {
            weight = 1
        }
        ))
    }

    fun getNextDiagnosisItem(){
        setStatusMessage("正在获取下一个问题")
        props.getNextDiagnosisItem(MedicalRecordRawData().apply{
            questionAndAnswers = conversationItems
            isDoctor = false
        },{ resp->
            if(resp.ok()){
                if(resp.data == null){
                    setStatusMessage("出错了，获取不到下一个问题")
                }else{
                    setStatusMessage("")
                    setConversationItems(resp.data!!)
                }
            }else{
                setStatusMessage("出错了:${resp.message}")
            }
        },{
            setStatusMessage("出错了:${it.message}")
        })
    }

    /**
     * 是否已完成当前问题的回答
     */
    fun isCompleted(item:DiagnosisQuestionAndAnswerItem):Boolean{
        val result = !item.signSymptomId.isNullOrBlank() && (item.characteristicOptions.isEmpty() || MedicalRecordSignSymptomState.不存在 == item.signSymptomState || (MedicalRecordSignSymptomState.存在 == item.signSymptomState && item.characteristicOptions.size>0 && item.signSymptomCharacteristics.size == item.characteristicOptions.size))
        //console.log(item,result,"result = !item.signSymptomId.isNullOrBlank() && (item.weight == 1 || item.characteristicOptions.isEmpty() || (item.characteristicOptions.size>0 && item.signSymptomCharacteristics.size == item.characteristicOptions.size))")
        return result;
    }

    /**
     * 更新答案
     */
    fun updateAnswer(index:Int,updatedItems:Array<DiagnosisQuestionAndAnswerItem>){
        updatedItems[index].weight = index+1
        setConversationItems(updatedItems)
        if(isCompleted(updatedItems[index])){
            getNextDiagnosisItem();
        }
    }

    div("DiagnosisConversationComponent") {
        if(props.patientId.isNullOrBlank()){
            alert {
                attrs{
                    message = "出错了，参数不全"
                }
            }
        }else {
            div("imessage") {
                conversationItems.forEachIndexed { index, item ->

                    if (item.reachTheEnd != null && item.reachTheEnd) {
                        p("from-them") {
                            +"好了，我没有更多问题了。您可以点按钮进入专家确认环节"
                        }
                        p {
                            attrs {
                                jsStyle = js {
                                    textAlign = "center"
                                }
                            }
                            button {
                                attrs {
                                    onClick = {
                                        props.onSubmit(MedicalRecordRawData().apply {
                                            patientId = props.patientId
                                            questionAndAnswers = conversationItems
                                            isDoctor = false
                                            source = "网络问诊"
                                            createdBy = props.patientId
                                        }, { resp ->
                                            if (resp.ok()) {
                                                setStatusMessage("提交成功，专家查看后将与您联系。")
                                            } else {
                                                setStatusMessage("提交出错：${resp.message}")
                                            }
                                        }, {
                                            setStatusMessage("提交出错：${it.message}")
                                        })
                                    }
                                }
                                +"提交专家确认"
                            }
                        }
                    } else {
                        if (index == 0) { //第一个默认都是选项症状
                            p("from-them") {
                                +"告诉我您遇到了什么问题，请从选择一个症状开始"
                            }
                            p("from-me") {
                                formItem {
                                    attrs {
                                        style = kotlinext.js.js {
                                            marginBottom = "0px"
                                        }
                                        label = "我的问题"
                                    }
                                    select<String, SelectComponent<String>> {
                                        attrs {
                                            style = js {
                                                minWidth = "150px"
                                            }
                                            //mode = "multiple"
                                            //size = "large"
                                            //mode = "tags"
                                            showSearch = true
                                            labelInValue = false
                                            value = item.signSymptomId
                                            placeholder = "请选择问题，如“失眠”"
                                            optionLabelProp = "label"
                                            filterOption = ::filterOptionFun
                                            //onSearch = fetchUser
                                            onChange = { selected: String, option: dynamic ->
                                                console.log("select value", selected)
                                                var items = Object.assign(
                                                    arrayOf<DiagnosisQuestionAndAnswerItem>(),
                                                    conversationItems
                                                )
                                                items[index].signSymptomId = selected
                                                val trimmedName =
                                                    if (option.label.indexOf("(") >= 0) "${option.label}".split("(")[0] else option.label
                                                items[index].signSymptomName = SignSymptomName.valueOf(trimmedName)
                                                items[index].signSymptomState = MedicalRecordSignSymptomState.存在
                                                items[index].characteristicOptions = arrayOf(
                                                    /*CascadedOption("微热|低热（<=38℃），或仅自觉发热而体温不高","ab493e7f66e94e52916ed9841511ea72"),
                                                CascadedOption("潮热|定时发热，或定时热甚，如潮汐之有定时者","4494198b0f2140859c9745846d58c1d9"),
                                                CascadedOption("壮热|高热（39 ℃以上）不退","a92127a5626b4674a2f61c0f2655dc88"),
                                                CascadedOption("寒热往来|恶寒和发热交替发作","d30f46e411fe40b2a354b78b8047e513"),*/
                                                )

                                                /*items += DiagnosisQuestionAndAnswerItem().apply {
                                                weight = 2
                                                signSymptomId = "aaaa"
                                                signSymptomName = SignSymptomName.恶寒
                                            }*/
                                                updateAnswer(index, items)
                                            }
                                            dropdownMatchSelectWidth = true
                                        }
                                        props.signSymptomOptions.forEach { optGroup ->
                                            if (optGroup.label != "脉象" && optGroup.label != "舌象") {
                                                optGroup {
                                                    attrs {
                                                        label = "${optGroup.label}"
                                                    }
                                                    optGroup.children?.forEach { opt ->
                                                        option {
                                                            attrs {
                                                                label = "${opt.label}"
                                                                value = "${opt.value}"
                                                            }
                                                            +"${opt.label}"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            /*if(!item.signSymptomId.isNullOrBlank() && !item.characteristicOptions.isNullOrEmpty()){ //如果选择的症状存在相关的特征
                            p("from-them"){
                                +"请告诉我您的${item.signSymptomName?.getLiteral()?:""}有哪些特征"
                            }
                            p("from-me"){
                                formItem{
                                    attrs{
                                        style = kotlinext.js.js {
                                            marginBottom = "0px"
                                        }
                                    }

                                    item.characteristicOptions.forEach{ characteristicOption ->
                                        val characteristicLabel = characteristicOption.label.split("|")
                                        formItem {
                                            attrs{
                                                label = characteristicLabel[0]
                                                if(characteristicLabel.size >0) {
                                                    tooltip = characteristicLabel[1]
                                                }
                                            }
                                            radioGroup {
                                                attrs{
                                                    value = item.signSymptomCharacteristics.firstOrNull { it.signSymptomCharacteristicId == characteristicOption.value }?.state
                                                    onChange = { event->
                                                        val indexOfFirst = item.signSymptomCharacteristics.indexOfFirst { it.signSymptomCharacteristicId == characteristicOption.value }
                                                        console.log("indexOfFirst",indexOfFirst,item.signSymptomCharacteristics,characteristicOption.value)
                                                        val items = Object.assign(arrayOf<DiagnosisQuestionAndAnswerItem>(),conversationItems)
                                                        if(indexOfFirst>=0){
                                                            items[index].signSymptomCharacteristics[indexOfFirst].state = event.target.value
                                                        }else{
                                                            items[index].signSymptomCharacteristics += MedicalRecordSignSymptomCharacteristic().apply{
                                                                signSymptomCharacteristicId = characteristicOption.value
                                                                state = event.target.value
                                                            }
                                                        }
                                                        console.log(items)
                                                        updateAnswer(index,items)
                                                    }
                                                }
                                                MedicalRecordSignSymptomCharacteristicState.values().forEach { stateOption ->
                                                    radioButton {
                                                        attrs{
                                                            value = stateOption
                                                        }
                                                        +"${stateOption.getLiteral()?:""}"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }*/
                        } else { //后续都是针对特定症状进行提问
                            if (item.signSymptomId.isNullOrBlank()) { //什么都没有，从零开始问
                                p("comment") {
                                    +"出错了：计算关联症状遇到问题...."
                                }
                            } else if (isCompleted(conversationItems[index - 1])) {
                                p("from-them") {
                                    +"是否存在${item.signSymptomName?.getLiteral() ?: ""}?"
                                }
                                p("from-me") {
                                    formItem {
                                        attrs {

                                            if(conversationItems[index].isAutoAnswered) {
                                                help = "基于${conversationItems[index].autoAnsweredType}[${conversationItems[index].autoAnsweredBasedOn?.map{it.name}?.joinToString("、")}]自动回答"
                                            }
                                            style = kotlinext.js.js {
                                                marginBottom = "0px"
                                            }
                                        }
                                        radioGroup {
                                            attrs {
                                                value = conversationItems[index].signSymptomState
                                                onChange = { event ->
                                                    val items = Object.assign(arrayOf<DiagnosisQuestionAndAnswerItem>(), conversationItems)
                                                    items[index].signSymptomState = event.target.value
                                                    updateAnswer(index, items)
                                                }
                                            }
                                            MedicalRecordSignSymptomState.values().forEach { stateOption ->
                                                radioButton {
                                                    attrs {
                                                        value = stateOption
                                                    }
                                                    +"${stateOption.getLiteral() ?: ""}"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        console.log(
                            "!item.signSymptomId.isNullOrBlank() && MedicalRecordSignSymptomState.存在 == item.signSymptomState && !item.characteristicOptions.isNullOrEmpty()",
                            !item.signSymptomId.isNullOrBlank() && MedicalRecordSignSymptomState.存在 == item.signSymptomState && !item.characteristicOptions.isNullOrEmpty()
                        )
                        if (!item.signSymptomId.isNullOrBlank() && MedicalRecordSignSymptomState.存在 == item.signSymptomState && !item.characteristicOptions.isNullOrEmpty()) { //如果选择的症状存在相关的特征
                            p("from-them") {
                                +"请告诉我您的${item.signSymptomName?.getLiteral() ?: ""}有哪些特征"
                            }
                            p("from-me") {
                                formItem {
                                    attrs {
                                        style = kotlinext.js.js {
                                            marginBottom = "0px"
                                        }
                                    }

                                    item.characteristicOptions.forEach { characteristicOption ->
                                        val characteristicLabel = characteristicOption.label.split("|")
                                        formItem {
                                            attrs {
                                                label = characteristicLabel[0]
                                                if (characteristicLabel.size > 0) {
                                                    tooltip = characteristicLabel[1]
                                                }
                                            }
                                            radioGroup {
                                                attrs {
                                                    value =
                                                        item.signSymptomCharacteristics.firstOrNull { it.signSymptomCharacteristicId == characteristicOption.value }?.state
                                                    onChange = { event ->
                                                        val indexOfFirst =
                                                            item.signSymptomCharacteristics.indexOfFirst { it.signSymptomCharacteristicId == characteristicOption.value }
                                                        console.log(
                                                            "indexOfFirst",
                                                            indexOfFirst,
                                                            item.signSymptomCharacteristics,
                                                            characteristicOption.value
                                                        )
                                                        val items = Object.assign(
                                                            arrayOf<DiagnosisQuestionAndAnswerItem>(),
                                                            conversationItems
                                                        )
                                                        if (indexOfFirst >= 0) {
                                                            items[index].signSymptomCharacteristics[indexOfFirst].state =
                                                                event.target.value
                                                        } else {
                                                            items[index].signSymptomCharacteristics += MedicalRecordSignSymptomCharacteristic().apply {
                                                                signSymptomCharacteristicId = characteristicOption.value
                                                                state = event.target.value
                                                            }
                                                        }
                                                        console.log(items)
                                                        updateAnswer(index, items)
                                                    }
                                                }
                                                MedicalRecordSignSymptomCharacteristicState.values()
                                                    .forEach { stateOption ->
                                                        radioButton {
                                                            attrs {
                                                                value = stateOption
                                                            }
                                                            +"${stateOption.getLiteral() ?: ""}"
                                                        }
                                                    }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                    }

                }
            }
        }
        div("status-message"){
            +statusMessage
        }
    }
}
